import { apiFetch } from "@/lib/api/client";

export function getPushPublicKey(): Promise<{ publicKey: string | null }> {
  return apiFetch("/push/public-key");
}

export function subscribeToPush(subscription: PushSubscriptionJSON): Promise<{ ok: true }> {
  return apiFetch("/push/subscribe", { method: "POST", body: JSON.stringify(subscription) });
}

export function unsubscribeFromPush(endpoint: string): Promise<{ ok: true }> {
  return apiFetch("/push/unsubscribe", { method: "POST", body: JSON.stringify({ endpoint }) });
}
